export const COLUMNS_CONSULTA_CODIGO_CUPO_PARA_ACTOR = [
  {
    name: 'exportador',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'fechaCupo',
    label: 'Fecha Cupo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cargador',
    label: 'Titular de cupo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'codigoCupo',
    label: 'Código de Cupo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'corredorVendedor',
    label: 'Corredor Vta. Secundaria',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'corredorComprador',
    label: 'Corredor Vta. Primaria',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'stopq',
    label: 'StopQ',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'estadoEnStopq',
    label: 'Estado en StopQ',
    options: {
      filter: true,
      sort: true
    }
  }
]
export const COLUMNS_CONSULTA_CODIGO_CUPO_PARA_ACTOR_TO_PRINT = [
  {
    name: 'exportador',
    label: 'Exportador',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fechaCupo',
    label: 'Fecha Cupo',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'codigoDeCupo',
    label: 'Código de Cupo',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'cargador',
    label: 'Titular de cupo',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'corredor',
    label: 'Corredor',
    width: 60,
    mantenerCase: true
  },

  {
    name: 'estadoEnStopQ',
    label: 'Estado en StopQ',
    width: 60,
    mantenerCase: true
  }
]
